/**
 * useOutstandingCount — live count of the OPEN list's Daily Operations items still needing
 * attention (needed / not-found / out-of-stock / un-prepped / un-cleaned /
 * unresolved). Drives the nav badge.
 *
 * Uses the same `isOpenItem` rule as the board (everything not yet moved to History),
 * so the badge always matches what's on the Today board. Listens to the last few days
 * only (a list older than that is long overdue to be moved). Pass `enabled=false`
 * (non-staff) to skip the Firestore listener entirely. Keeps only the number, so the
 * nav re-renders when the count changes — not on every item update.
 */
import { useFeed } from './useFeed';
import { subscribeRecentItems } from '../data/items';
import { itemStatus } from '../logic/items';
import { isOpenItem } from '../logic/openList';
import { STATUS, RETIRED_LIST_IDS } from '../config/lists';

const BADGE_DAYS = 3;   // the open list is normally ≤ 1–2 days old

export const countOutstanding = items => items.filter(i =>
  isOpenItem(i) && !RETIRED_LIST_IDS.includes(i.category) && itemStatus(i) !== STATUS.REFILLED,
).length;

export function useOutstandingCount(enabled = true) {
  const { data, error } = useFeed('badge',
    (onData, onError) => subscribeRecentItems(BADGE_DAYS, onData, onError),
    { initial: 0, enabled, select: countOutstanding });
  return error ? 0 : data;
}
